module.exports = __webpack_public_path__ + "static/media/disable-grey.423f760a.svg";